import produce from 'immer'

import {
  LOADING_PROJECT_MEMBERS,
  SET_PROJECT_MEMBERS,
  LOADING_PROJECT_DETAILS,
  SET_PROJECT_DETAILS,
  DELETING_PROJECT_DATASETS,
  LOADING_PROJECT_DATASETS,
  SET_PROJECT_DATASETS,
  UPDATE_PROJECT_DATASET,
  LOADING_PROJECT_SUBPROJECTS,
  SET_PROJECT_SUBPROJECTS,
  LOADING_PROJECT_PARENT,
  SET_PROJECT_PARENT,
  MOVING_PROJECT_CONTENT,
  LOADING_PROJECT_INITIAL_TREE,
  SET_PROJECT_ROOT,
  SET_PROJECT_INITIAL_TREE,
  SET_PROJECT_SUBPROJECTS_TREE,
  SET_PROJECT_PATH,
  SET_PROJECT_PAGINATION,
  SET_PROJECT_ROWSPERPAGE,
  SET_PROJECT_CONTENT,
  RESET_PROJECT_CONTENT
} from '../actions/project'

const initState = {
  pagination: {
    page: 0,
    rowsPerPage: 0
  },
  details: {
    capabilities: null,
    data: null,
    loading: true,
    projectId: null
  },
  datasets: {
    data: null,
    loading: false,
    deleting: false,
    updating: false
  },
  members: {
    data: null,
    loading: false
  },
  subprojects: {
    data: null,
    loading: false
  },
  parent: {
    data: null,
    loading: false
  },
  tree: {
    data: null,
    loading: false
  },
  initialtree: {
    data: { project: [] },
    loading: false
  },
  content: {
    moving: false
  },
  path: {
    data: null,
    // The folder `data` was fetched for, so a trail left over from the
    // previous folder is never mistaken for the current one.
    projectId: null
  },
  projectContent: {
    // The project the loaded list belongs to. Views use it to tell whether the
    // content in the store is the one they are about to show.
    projectId: null,
    data: [],
    sortBy: 'updatedAt',
    sortOrder: 'desc',
    totalCount: 0,
    page: 0,
    namePrefix: '',
    rowsPerPage: 25
  }
}

export default produce((draft, action) => {
  switch (action.type) {
    case SET_PROJECT_PAGINATION:
      draft.pagination.page = action.page
      return

    case SET_PROJECT_ROWSPERPAGE:
      draft.pagination.rowsPerPage = action.rowsPerPage
      return

    case UPDATE_PROJECT_DATASET:
      draft.datasets.updating = action.updating
      return

    case DELETING_PROJECT_DATASETS:
      draft.datasets.deleting = action.deleting
      return

    case LOADING_PROJECT_DETAILS:
      draft.details.loading = action.loading
      draft.details.projectId = action.projectId
      return

    case SET_PROJECT_DETAILS:
      draft.details.data = action.details
      draft.details.capabilities = action.capabilities
      return

    case SET_PROJECT_MEMBERS:
      draft.members.data = action.members
      return

    case LOADING_PROJECT_MEMBERS:
      draft.members.loading = action.loading
      return

    case LOADING_PROJECT_DATASETS:
      draft.datasets.loading = action.loading
      return

    case SET_PROJECT_DATASETS:
      draft.datasets.data = action.datasets
      return

    case LOADING_PROJECT_SUBPROJECTS:
      draft.subprojects.loading = action.loading
      return

    case SET_PROJECT_SUBPROJECTS:
      draft.subprojects.data = action.subprojects
      return

    case LOADING_PROJECT_PARENT:
      draft.parent.loading = action.loading
      return

    case SET_PROJECT_PARENT:
      draft.parent.data = action.parentProject
      return

    case MOVING_PROJECT_CONTENT:
      draft.content.moving = action.moving
      return

    case LOADING_PROJECT_INITIAL_TREE:
      draft.initialtree.loading = action.loading
      return

    case SET_PROJECT_ROOT:
      draft.tree.data = action.rootProject
      return

    case SET_PROJECT_INITIAL_TREE:
      draft.initialtree.data = action.initialtree
      return

    case SET_PROJECT_SUBPROJECTS_TREE:
      draft.tree.data = {
        ...action.tree,
        [action.parentProjectId]: action.subprojects || []
      }
      return

    case SET_PROJECT_PATH:
      draft.path.data = action.data
      draft.path.projectId = action.projectId
      return

    case SET_PROJECT_CONTENT:
      draft.projectContent = {
        projectId: action.projectId,
        data: action.projectContent,
        page: action.page,
        rowsPerPage: action.rowsPerPage,
        sortBy: action.sortBy,
        sortOrder: action.sortOrder,
        namePrefix: action.namePrefix,
        totalCount: action.totalCount
      }
      return

    case RESET_PROJECT_CONTENT:
      // Only the list is dropped — sort, paging and the name filter are the
      // user's preferences and survive the move to another project.
      draft.projectContent.projectId = null
      draft.projectContent.data = []
      draft.projectContent.totalCount = 0
      return

    default:
      return
  }
}, initState)
